import { render, staticRenderFns } from "./NotificationDetailTemp.vue?vue&type=template&id=011d398a&scoped=true"
import script from "./NotificationDetailTemp.vue?vue&type=script&lang=js"
export * from "./NotificationDetailTemp.vue?vue&type=script&lang=js"
import style0 from "./NotificationDetailTemp.vue?vue&type=style&index=0&id=011d398a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011d398a",
  null
  
)

export default component.exports